<template>
  <rect x="3" width="24" height="24" rx="12" fill="#D6D6D6" />
  <rect x="35" width="24" height="24" rx="12" fill="#97A1BA" />
</template>
